// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/dialog/dialog.js#1 $
'use strict';

angular.module('tcApp')
.service('DialogService', function($mdDialog, $window, WorkflowService) {
	/**
	* @ngdoc method
	* @name showDialog
	* @methodOf tcApp.DialogService
	* @description
	* Opens a dialog window with the specified route URL.
	* Uses the tcDialog controller
	*/
	var showDialog = function($event, currentRoute) {

		$mdDialog.show({
			controller: currentRoute.controller,
			controllerAs: currentRoute.controllerAs,
			template: getTemplate(currentRoute),
			resolve: getModifiedResolve(currentRoute),
			bindToController: true,
			targetEvent: $event,
			clickOutsideToClose: false,
			escapeToClose: false,
			disableParentScroll: true,
			focusOnOpen: false,
			parent: angular.element($window.document.querySelector('#tc_Home-misc-body')),
		});

	};

	/**
	* @ngdoc method
	* @name closeDialog
	* @methodOf tcApp.DialogService
	* @description
	* Closes the active dialog
	*/
	var closeDialog = function() {
		this.closingDialog = true;
		$window.history.back();
	};

	var backDialog = function() {
		$window.history.back();
	};

	// Modify URL to include Dialog parameter
	var getDialogUrl = function(url) {
		return WorkflowService.getNextLevelUrl(url);
	};

	function getTemplate(currentRoute) {
		return '<md-dialog aria-label="Dialog" tc-handle-dialog-escape>'
			+ ' <md-dialog-content>'
			+ '  <div ng-if="dialogError">{{ dialogError }}</div>'
			+ currentRoute.template
			+ ' </md-dialog-content>'
			+ '</md-dialog>';
	}
	
	function getModifiedResolve(currentRoute) {
		var modifiedResolve = angular.copy(currentRoute.resolve);
		// dialogResolve is used by router to reject route change when opening a dialog.
		// We need to delete it when acually showing the dialog.
		delete modifiedResolve.dialogResolve;
		
		// Add dialog-related component options
		modifiedResolve.options = function() {
			return {
				dialogCount: currentRoute.params.Dialog ? parseInt(currentRoute.params.Dialog,10) : 0,
				displayMode: 'dialog'
			};
		};
		return modifiedResolve;
	}

	return {
		backDialog: backDialog,
		closeDialog: closeDialog,
		closingDialog: false,
		getDialogUrl: getDialogUrl,
		showDialog: showDialog,
	};
});
